// import mapModule from './map'
import mapModule from './map-leaflet'
import $ from 'jquery'

// WayPoints
import 'waypoints/lib/jquery.waypoints.min.js'
import 'waypoints/lib/shortcuts/sticky'
import 'waypoints/lib/shortcuts/inview'

// Fotorama
import 'fotorama/fotorama.js'
import 'fotorama/fotorama.css'

import 'bootstrap-datepicker'
import ReservationPanel from './components/reservation-panel'

/* MAP */
function load_map() {
  $('.js-map').show();
  const m = new mapModule($('.js-map'))
  m.run()
  ga('send', 'event', 'map', 'load')
}
window.load_map = load_map
export default load_map

if(!$('body').data('userisstaff')) {
  /* load_map()  /* Better lazy load */
} else {
  $('#show-map-btn').click(function() {
    $(this).hide();
    load_map();
  })
}

/* Hide map if quota is over */
$(document).ready( function() {
    if(!$('body').data('userisstaff')) {

      function check_quota() {
          if (ct >= 20) {
            window.clearInterval(check_quota_interval);
          }
          ct = ct + 1;
          if (typeof($("button.dismissButton")[0]) === "undefined") return;
          $('.js-map').hide();
          window.clearInterval(check_quota_interval);
      }

      var check_quota_interval = window.setInterval(check_quota, 1000);
      var ct = 0
    }
});

/* RESERVATION PANEL */
if ($('.activity-section .reservation-panel:not(.with-existing-order)').length) {
  new ReservationPanel(I18N_TRANSLATION)
}

// TODO:: Refactor, for Mobile, windows resize, and header height dynamic
if ($('.js-waypoint-sticky').length) {
  new Waypoint.Sticky({
    element: $('.js-waypoint-sticky')[0],
    stuckClass: 'js-stuck',
    offset: 98,
    // offset: $('.main-navbar').height() + $('.price-heading').height(),
    handler: function (direction) {
      if ($(this.element).hasClass('js-stuck')) {
        let w = $($(this.element).data('parent-width-ref')).width()
        $(this.element).css({width: w})
      } else {
        $(this.element).css('left', 'auto')
      }
    }
  })
}

let $rpc = $('.reservation-panel-content')
let $rpc_collapse = $('.collapse-reservation-panel')
if($rpc.length == 1 && $rpc_collapse.length == 1) {
  $rpc.collapse()
  new Waypoint.Inview({
      element: $('.collapse-reservation-panel')[0],
      enter: function (direction) {
          if (!$rpc.hasClass('mobile'))
              $rpc.collapse('hide');
      },
      exited: function (direction) {
          if (direction == 'up')
              if (!$rpc.hasClass('mobile'))
                  $rpc.collapse('show');
      }
  });
}

if($('.activity-section.sticky-navbar').length) {
  $('.activity-section.sticky-navbar li a').on('click', function(){
    let li = $(this).parent()
    li.siblings().removeClass('active')
    li.addClass('active')
  })
}



// WEBPACK FOOTER //
// ./activity/static/activity/js/apps.js